import { Box, Typography } from '@mui/material'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router'
import { getHomeResources } from '../../../../redux/actions/resources'
import { IRootState } from '../../../../redux/types'
import FeedHeader from '../../styles/FeedHeader'
import HomeResourcesFeedSkeleton from '../skeletons/HomeResourcesFeedSkeleton'
import CardsFeed from './CardsFeed'

function ResourcesFeed() {
  const { t } = useTranslation(['global'])
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const { feedResources, loading: resourcesLoading } = useSelector((state: IRootState) => state.resource)
  const { globalCountryId, globalLanguageId } = useSelector((state: IRootState) => state.global)

  useEffect(() => {
    dispatch(
      getHomeResources({
        country_id: globalCountryId,
        language_id: globalLanguageId
      })
    )
  }, [globalCountryId, globalLanguageId])

  return (
    <>
      {resourcesLoading ? (
        <HomeResourcesFeedSkeleton />
      ) : (
        <>
          {feedResources.length > 0 && (
            <FeedHeader xs={12}>
              <Box display="flex" justifyContent="space-between" alignItems="center">
                <Typography variant="h5">{t('library-updates')}</Typography>
                <Typography
                  sx={theme => ({
                    textDecoration: 'underline',
                    cursor: 'pointer',
                    '&:hover': {
                      color: theme.palette.primary.dark
                    }
                  })}
                  onClick={() => {
                    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
                    navigate(`/biblioteca`)
                  }}
                  color="textSecondary"
                  style={{ textDecoration: 'underline', cursor: 'pointer' }}
                >
                  {t('see-more')}
                </Typography>
              </Box>
            </FeedHeader>
          )}
        </>
      )}

      <Box width="100%">
        <CardsFeed resources={feedResources} />
      </Box>
    </>
  )
}

export default ResourcesFeed
